<template>
  <div class="markdown-wrapper" style="height:100%">
    <v-md-editor
      v-model="text"
      height="100%"
      :disabled-menus="[]"
      @save="onSave"
      @upload-image="handleUploadImage">
    </v-md-editor>
  </div>
</template>

<script>
// v-md-editor 文档地址 http://ckang1229.gitee.io/vue-markdown-editor/zh/#%E4%BB%8B%E7%BB%8D
import { uploadImage } from '@/api/data'

export default {
  name: 'MarkdownEditor',
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: () => {
        return {}
      }
    },
    localCache: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      text: this.value,
      timer: null
    }
  },
  methods: {
    onSave (content) {
      this.$emit('save', content)
    },
    upload (file, insertImage) {
      uploadImage(file).then(resp => {
        if (resp.data.ok) {
          insertImage({
            url: resp.data.url,
            desc: resp.data.name
          })
        } else {
          this.$Notice.warning({
            'title': '上传失败', 'desc': '图片上传失败'
          })
        }
      })
    },
    handleUploadImage (event, insertImage, files) {
      if (files.length > 0) {
        let file = files[0]
        console.log('file type:', file.type)
        switch (file.type) {
        case 'image/heic':{
          this.upload(file, insertImage)
          break
        }
        default:{
          this.$scale_img(file).then(scaledFile => {
            this.upload(scaledFile, insertImage)
          })
          break
        }
        }
      }
      console.log('upload image -->', event, insertImage, files)
    },
    setInterval () {
      if (this.timer) {
        clearInterval(this.timer)
      }
      this.timer = setInterval(() => {
        this.$emit('auto-save', this.text)
      }, 5000)
    }
  },
  mounted () {
    this.setInterval()
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  watch: {
    value () {
      this.text = this.value
    }
  }
}
</script>

<style lang="less">
.markdown-wrapper{
  .editor-toolbar.fullscreen{
    z-index: 9999;
  }
  .CodeMirror-fullscreen{
    z-index: 9999;
  }
  .CodeMirror-fullscreen ~ .editor-preview-side{
    z-index: 9999;
  }
}
</style>
